<template lang='pug'>
  bionic-metrics-page-loading(title='Installing Slack Integration')
</template>

<script>
import {mapActions} from 'vuex';
import Notifications from '../../../services/notification.service';
import Slack from '../../../api/slack';
import BionicMetricsPageLoading from '../../../components/PageLoading';

export default {
  components: {BionicMetricsPageLoading},
  name: 'InstallSlack',
  async created() {
    const {code} = this.$route.query;
    if (!code) return Notifications.errorToast('Invalid Installation Code. Aborting').then(this.abort);
    try {
      await Slack.install(code);
      await this.refreshUser(); // so our stored user/account reflects reality
      Notifications.toast('Slack App Installed Successfully');
      return this.$router.push('/');
    } catch (err) {
      console.error(err);
      Notifications.alert('There was a problem installing. Please uninstall and try again.');
      return this.abort();
    }
  },
  methods: {
    abort() {
      this.$router.push('/');
    },
    ...mapActions({
      refreshUser: 'refreshUser'
    })
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
